import { FunctionComponent } from 'react';
import { Box, Text } from '@chakra-ui/react';

type ComputedCellProps = {
  value: number | null;
  /** Formato do valor — "number" padrão, "percent" para win_rate, "signed" para SG. */
  format?: 'number' | 'percent' | 'signed';
};

const formatValue = (value: number | null, format: ComputedCellProps['format']): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  if (format === 'percent') return `${value.toFixed(2).replace('.', ',')}%`;
  if (format === 'signed') return value > 0 ? `+${value}` : `${value}`;
  return `${value}`;
};

const colorForSigned = (value: number | null): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return 'gray.500';
  if (value > 0) return 'green.600';
  if (value < 0) return 'red.600';
  return 'gray.500';
};

/**
 * Célula somente-leitura calculada (J, SG, win_rate). Sempre cinza, sem input.
 */
export const ComputedCell: FunctionComponent<ComputedCellProps> = ({ value, format = 'number' }) => {
  const color = format === 'signed' ? colorForSigned(value) : 'gray.500';
  return (
    <Box
      borderRadius="md"
      px={2}
      py={1}
      textAlign="center"
      bg="gray.50"
    >
      <Text fontSize="sm" fontWeight="medium" color={color}>
        {formatValue(value, format)}
      </Text>
    </Box>
  );
};
